import { Component, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ELearningManagementService } from '../e-learning-management/e-learning-management.service';

@Component({
  selector: 'app-e-learning-management-ta',
  templateUrl: './e-learning-management-ta.component.html',
  styleUrls: ['./e-learning-management-ta.component.scss']
})
export class ELearningManagementTaComponent implements OnInit {

  isLoading: boolean;
  allCourse: any;
  search: string;
  isSearch: boolean = false;

  data = [];
  searchCourse: any = '';

  constructor(
    private gobalFunctionService: GobalFunctionService,
    private elearningManagementService: ELearningManagementService,
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('จัดการคอร์สเรียน');
    this.getAllCourse();
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchCourse = [];
      this.allCourse.filter(c => {
        if (c.COURSE_ID.toLowerCase().includes(this.search.toLowerCase()) || c.USERNAME.toLowerCase().includes(this.search.toLowerCase()) || c.COURSE_NAME.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchCourse.push(c)
        }
      });
    } else {
      this.isSearch = false;
      this.searchCourse = null;
      this.getAllCourse();
    }
  }

  getAllCourse() {
    this.elearningManagementService.getAllCourse().subscribe(res => {
      // console.log(res);

      this.allCourse = res.result.map(el => {
        return {
          COURSE_ID: el.COURSE_NUMBER,
          COURSE_NAME: el.COURSE_NAME,
          COURSE_STATUS: el.COURSE_STATUS,
          USERNAME: el.USERNAME,
          MESSAGE_ALERT: el.MESSAGE_ALERT,
        }
      })
    })
  }

  privateChat(cid) {
    window.open('/e-learning-management/private-chat-management?course_id=' + cid, '_blank');
  }
}
